import { ExternalLink, MapPin, Phone } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { WhatsAppIcon } from "@/components/site/WhatsAppFloat";
import { ATENDIMENTO, BRAND, LINKS, waLink } from "@/lib/content";

export default function Contato() {
  return (
    <div data-testid="page-contato">
      <PageHero eyebrow="Contato" title="Fale com o Nillo">Atendimento em {BRAND.atendimento}. Responsável técnico: {BRAND.responsavel}.</PageHero>
      <section className="mx-auto grid max-w-7xl gap-6 px-4 py-16 sm:px-6 lg:grid-cols-3">
        <a href={waLink("Olá, Nillo Ruídos!")} target="_blank" rel="noreferrer" className="group flex flex-col justify-between bg-[#DC2626] p-8 transition-colors hover:bg-[#EF4444] lg:col-span-2" data-testid="contato-whatsapp">
          <WhatsAppIcon className="h-10 w-10 text-white" />
          <div className="mt-10">
            <p className="font-mono text-xs uppercase tracking-widest text-red-100">WhatsApp / Telefone</p>
            <p className="font-heading text-4xl font-bold text-white sm:text-5xl">{BRAND.telefone}</p>
          </div>
        </a>
        <div className="card-tech space-y-4 p-8">
          <p className="flex items-center gap-3 text-slate-300"><Phone className="h-4 w-4 text-red-500" />{BRAND.telefone}</p>
          <p className="flex items-center gap-3 text-slate-300"><MapPin className="h-4 w-4 text-red-500" />Atendimento: {ATENDIMENTO.regiao}</p>
          <p className="text-sm text-slate-400">Preferencialmente em {ATENDIMENTO.preferencial.join(", ").toLowerCase()}. {ATENDIMENTO.domicilio}</p>
          <p className="text-sm text-slate-400">Instagram {BRAND.instagram} · Facebook {BRAND.facebook}</p>
        </div>
        <div className="grid gap-px bg-slate-800 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-5">
          {LINKS.map((l, i) => (
            <a key={l.url} href={l.url} target="_blank" rel="noreferrer" data-testid={`contato-link-${i}`} className="flex items-center justify-between bg-[#111723] p-6 font-heading font-bold uppercase text-white transition-colors hover:bg-[#161E2E] hover:text-red-400">
              {l.titulo} <ExternalLink className="h-4 w-4 text-red-500" />
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
